import { GraftConfig as MailingGraftConfig } from '@graft/nuget-gc.webportals.mailing'

import { readGraftWebserviceUrl } from '@common/core/config/utils/read-graft-webservice-url.util'

const mailingUrl = readGraftWebserviceUrl('MAIL')

if (mailingUrl) {
  MailingGraftConfig.host = mailingUrl
  MailingGraftConfig.stateless = true
}
